import Line from './Line';
import Bar from './Bar';
import Pie from './Pie';
import Number from './Number';
import ProgressBar from './ProgressBar';
import Table from './Table';
import PivotTable from './PivotTable';
import DualAxis from './DualAxis';
import MapView from './MapView';
import HtmlViewer from './HtmlViewer';

const visualisationMap = {
  line: Line,
  bar: Bar,
  pie: Pie,
  number: Number,
  progressBar: ProgressBar,
  table: Table,
  pivotTable: PivotTable,
  dualAxes: DualAxis,
  map: MapView,
  htmlViewer: HtmlViewer,
};

export default visualisationMap;
